<template>
  <main class="route-load-error">
    <section class="route-load-error__card">
      <div class="route-load-error__icon" aria-hidden="true">!</div>
      <h1>{{ t("load_failed") }}</h1>
      <p>{{ t("page_and_refresh") }}</p>
      <button type="button" @click="reloadPage">{{ t("refresh") }}</button>
    </section>
  </main>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import { useTranslate } from "@/libs/utils";

const route = useRoute();
const t = useTranslate();

function reloadPage() {
  const requestedPath =
    typeof route.query.from === "string" ? route.query.from : "";
  const from = requestedPath.startsWith("/") ? requestedPath : "/finder";
  window.location.assign(from);
}
</script>

<style scoped>
.route-load-error {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: #f4f6f9;
}

.route-load-error__card {
  width: min(420px, 100%);
  padding: 40px 32px;
  border-radius: 16px;
  background: #fff;
  text-align: center;
  box-shadow: 0 8px 32px rgb(31 41 55 / 8%);
}

.route-load-error__icon {
  width: 42px;
  height: 42px;
  margin: 0 auto 16px;
  border-radius: 50%;
  color: #fff;
  background: #4d65ff;
  font-size: 28px;
  font-weight: 700;
  line-height: 42px;
}

h1 {
  margin: 0;
  color: #191d1f;
  font-size: 20px;
}

p {
  margin: 12px 0 24px;
  color: rgb(25 29 31 / 60%);
}

button {
  min-width: 120px;
  padding: 10px 20px;
  border: 0;
  border-radius: 8px;
  color: #fff;
  background: #4d65ff;
  cursor: pointer;
  font-size: 14px;
}
</style>
